import { Injectable, signal } from '@angular/core';

export type ToastType = 'error' | 'success';

export interface ToastMessage {
  id: number;
  message: string;
  type: ToastType;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 0;

  readonly messages = signal<ToastMessage[]>([]);

  success(message: string): void {
    this.show(message, 'success');
  }

  error(message: string): void {
    this.show(message, 'error');
  }

  dismiss(id: number): void {
    this.messages.update((messages) =>
      messages.filter((message) => message.id !== id),
    );
  }

  private show(message: string, type: ToastType): void {
    const id = ++this.nextId;
    this.messages.update((messages) => [...messages, { id, message, type }]);
    if (type === 'success') {
      setTimeout(() => this.dismiss(id), 5000);
    }
  }
}
